import { Anchor, BackgroundImage, Badge, Box, Button, Card, Center, Chip, Container, Grid, Group, Image, Modal, Stack, Text } from '@mantine/core';
import React, { useState } from 'react';
import ProjectCard from './ProjectCard';
import { House, Tag, Buildings } from '@phosphor-icons/react';
import ProjectContactForm from './ProjectContactForm';



export const BUKIT_JALIL_PROJECTS = [
    {
        title: "One Plus Plus",
        description: <div>
            <ul>
                <li>Tenure: 1 year (optional to renew)</li>
                <li>Minimum Investment: RM 20,000</li>
                <li>Payout: Quarterly</li>
                <li>Return (per annum): 8.5% + 11% + 11%</li>
            </ul>
        </div>,
        bannerImageUrl: "/trusts/oneplusplus-banner.png",
        mainImageUrl: "/trusts/oneplusplus-main.png",
        brochureLink: "/trust-pdf/One Plus Plus.pdf",
    },
    
    {
        title: "HiTrust",
        description: <div>
            <ul>
                <li>Tenure: 2 years</li>
                <li>Minimum Investment: RM 10,000</li>
                <li>Payout: Yearly</li>
                <li>Return (per annum): 10%</li>
            </ul>
        </div>,
        bannerImageUrl: "/trusts/hitrust-banner.png",
        mainImageUrl: "/trusts/hitrust-main.png",
        brochureLink: "/trust-pdf/Hi Trust.pdf",
    },
    {
        title: "Vanguard Family Trust",
        description: <div>
            <ul>
                <li>Tenure: 1 year</li>
                <li>Minimum Investment: RM 30,000</li>
                <li>Payout: Quarterly</li>
                <li>Return (per annum): 10%</li>
            </ul>
        </div>,
        bannerImageUrl: "/trusts/vanguard-banner.png",
        mainImageUrl: "/trusts/vanguard-main.png",
        brochureLink: "/trust-pdf/Vanguard Family Trust.pdf",
    },
    {
        title: "Gemilang Trust",
        description: <div>
            <ul>
                <li>Tenure: 3 years</li>
                <li>Return (per annum): 11%</li>
            </ul>

            <ul>
                <li>Minimum Investment: RM 50,000</li>
                <li>Payout: Yearly</li>
            </ul>

            <ul>
                <li>Minimum Investment: RM 1,000,000</li>
                <li>Payout: Half-Yearly</li>
            </ul>
        </div>,
        bannerImageUrl: "/trusts/gemilang-banner.png",
        mainImageUrl: "/trusts/gemilang-main.png",
        brochureLink: "/trust-pdf/Gemilang Trust.pdf",
    },
    {
        title: "Mega Trustee Contingency Trust",
        description: <div>
            <ul>
                <li><strong>Contingency Trust</strong></li>
                <li>Tenure: 1 year</li>
                <li>Minimum Investment: RM 30,000</li>
                <li>Payout: Quarterly</li>
                <li>Return:
                    <ul>
                    <li>&lt; RM250,000: 8%</li>
                    <li>&gt; RM250,000: 9%</li>
                    <li>&gt; RM1,000,000: 10%</li>
                    </ul>
                </li>
            </ul>          
        </div>,
        bannerImageUrl: "/trusts/megatrustee-banner.png",
        mainImageUrl: "/trusts/megatrustee-main.png",
        brochureLink: "/trust-pdf/Mega Trustee Contingency.pdf",
    },
    {
        title: "Mega Trustee Estate Trust",
        description: <div>
            <ul>
                <li>Tenure: 3 years</li>
                <li>Minimum Investment: RM 50,000</li>
                <li>Payout: Quarterly</li>
                <li>Return:
                    <ul>
                    <li>&lt; RM250,000: 9%</li>
                    <li>&gt; RM250,000: 11%</li>
                    <li>&gt; RM500,000: 13%</li>
                    </ul>
                </li>
            </ul>  
        </div>,
        bannerImageUrl: "/trusts/mt-banner.png",
        mainImageUrl: "/trusts/mt-main.png",
        brochureLink: "/trust-pdf/Mega Trustee Estate.pdf",
    },
]

const logos = [
    {
        title: "Propnex",
        img: "/propnex.png",
    },
    {
        title: "IQI",
        img: "/iqi.png",
    },
    {
        title: "Kith & Kin",
        img: "/kithandkin.png",
    },
];

const Trusts = () => {
    const [opened, setOpened] = useState(false)


    return (
        <>
            <Modal
                centered
                opened={opened}
                onClose={() => setOpened(false)}
                title={"Register your interest"}
            >
                <ProjectContactForm submitCallback={() => setOpened(false)}/>
            </Modal>
            <Container size="1440px" p={24}>
                <Stack>
                    <Stack spacing={4}>
                        <Text align="center" component='h1' fz={36} sx={{ lineHeight: 1, margin: 0, color: "#1F8150" }}>Trust  Products</Text>
                        <Text align="center" component='h1' fz={24} sx={{ lineHeight: 1, margin: 0 }} fw={600}> <Text component='span' sx={{ color: "#1F8150" }}>Create</Text> and <Text component='span' sx={{ color: "#1F8150" }}>diversify</Text> your wealth through our selected products</Text>
                        <Text align="center" component='h4' fw={600}>There are so many new projects available - but we at Propmoth have reviewed and selected the ones that we determine to be the best</Text>
                    </Stack>
                    <Grid>
                        {BUKIT_JALIL_PROJECTS.map(project => (
                            <Grid.Col sm={12} md={6}>
                                <ProjectCard project={project} />
                            </Grid.Col>
                        ))}
                    </Grid>
                    {/* <Card>
                        <Stack>
                            <Text align='center'>We've selected the best agencies that cover these projects. Your number will not be shared with anyone else.</Text>
                            <Container size={1000}>
                                <Grid gutter={24}>
                                    {logos.map((logo) => (
                                        <Grid.Col xs={12} sm={4}>
                                            <Center sx={{ height: "100%" }}>
                                                <Image
                                                    src={logo.img}
                                                    alt={logo.title}
                                                    fit="contain"
                                                    width={150}
                                                />
                                            </Center>
                                        </Grid.Col>
                                    ))}
                                </Grid>
                            </Container>
                            <Group position='center'>
                                <Button onClick={() => setOpened(true)}>Register Your Interest</Button>
                            </Group>
                            <Stack sx={{ color: 'red' }} spacing={4}>
                                <Text align='center' fw={'bold'}>*Important Note*</Text>
                                <Text align='center'>
                                    If the person you are talking to is being unprofessional or is not taking care of your inquiry properly, please let us know here so we can take action.
                                </Text>
                                <Text align='center'>
                                    Propmoth is a platform that caters to buyers. We want to make sure that you are properly taken care of.
                                </Text>
                            </Stack>
                            <Text component='h1' align='center'>Not interested in these projects? <Anchor href="/register" sx={{ textDecoration: "underline" }}>Register</Anchor> on our Propmoth to find your desired property! We're the “Smartest Way To Find Property” </Text>
                        </Stack>
                    </Card> */}
                </Stack>
            </Container>
        </>
    );
};

export default Trusts;